import React from 'react'
import CanonicalImg from '../../Img'

// COMPAT SHIM (task #67). ProgressiveImage is now a thin wrapper over the
// canonical <Img>. The old client-side `new Image()` swap + blur state is gone:
// blur-up is pure CSS over the resolved placeholder, so this is a static SSR
// <img> with no hydration cost and no manifest import.
//
// Accepts a ResolvedImage descriptor as `image`, OR (for the many spread call
// sites that pass `{...mainImage}` / `{...galleryImages[0]}`) the descriptor
// fields directly (src/srcSet/width/height/placeholderUrl) or the legacy
// { src, placeholderSrc } pair. A base64 placeholderSrc is dropped.
function ProgressiveImage({
  image,
  src,
  srcSet,
  width,
  height,
  placeholderUrl,
  placeholderSrc,
  alt,
  className,
  sizes = '100vw',
  priority = false,
  objectFit = 'contain',
}) {
  const blur =
    placeholderUrl ||
    (placeholderSrc && !placeholderSrc.startsWith('data:') ? placeholderSrc : undefined)

  const descriptor =
    image && typeof image === 'object'
      ? image
      : src
      ? { src, srcSet: srcSet || undefined, width, height, placeholderUrl: blur }
      : null

  if (!descriptor) return null

  return (
    <CanonicalImg
      image={descriptor}
      alt={alt}
      className={className}
      sizes={sizes}
      priority={priority}
      objectFit={objectFit}
    />
  )
}

export default ProgressiveImage
